import { NumberSettingData } from "./interfaces";

export const MaxVisibleSegments = 23;

export const padding = 1; // extra space on each side

export const StepSettings: { [key: string]: number } = {
  "Whole Numbers": 1,
  "Decimals (Tenths)": 0.1,
  "Fractions (Halves)": 1 / 2,
  "Fractions (Thirds)": 1 / 3,
  "Fractions (Quarters)": 1 / 4,
};

export const Denominators: { [size: string]: number } = {
  "Fractions (Halves)": 2,
  "Fractions (Thirds)": 3,
  "Fractions (Quarters)": 4,
};

export const MODAL_NEW_NUMBER_SPAN = "newNumberSpan";

export const INITIAL_DATA = {
  operand: "plus",
} as NumberSettingData;
